import { useState, useMemo } from "react"
import React from 'react';
import { dispensaries,strains  } from "../data/data";

function cn(...classes) {
  return classes.filter(Boolean).join(' ')
}

// ========== DISPENSARY DETAIL PAGE ==========
export function DispensaryDetailPage({ slug }) {
  const dispensary = dispensaries.find((d) => d.slug === slug)

  if (!dispensary) {
    return <div>Dispensary not found</div>
  }

  const renderMenu = (menuItems) => {
    if (menuItems.length === 0) {
      return <p style={{ color: '#6b7280', padding: '16px' }}>Nothing available in this category right now.</p>
    }
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {menuItems.map((item) => {
          const strain = strains.find((s) => s.id === item.strainId)
          if (!strain) return null
          const avgRating =
            strain.reviews.length > 0 ? strain.reviews.reduce((acc, r) => acc + r.rating, 0) / strain.reviews.length : 0

          return (
            <div 
              key={item.strainId} 
              onClick={() => console.log(`Navigate to strain: ${strain.slug}`)}
              style={{ cursor: 'pointer' }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '12px',
                borderRadius: '8px',
                transition: 'background-color 0.2s',
                backgroundColor: 'rgba(0,0,0,0.05)'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(0,0,0,0.1)'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(0,0,0,0.05)'}
              >
                <div>
                  <p style={{ fontWeight: '600', margin: 0 }}>{strain.name}</p>
                  <p style={{ fontSize: '14px', color: '#6b7280', margin: '4px 0 0 0' }}>
                    {strain.type} • THC: {strain.thc}%
                  </p>
                  {avgRating > 0 && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px', marginTop: '4px' }}>
                      <span style={{ color: '#f59e0b' }}>⭐</span>
                      <span>
                        {avgRating.toFixed(1)} ({strain.reviews.length} reviews)
                      </span>
                    </div>
                  )}
                </div>
                <div style={{ textAlign: 'right' }}>
                  <p style={{ fontWeight: 'bold', fontSize: '18px', color: '#10b981', margin: 0 }}>${item.price.toFixed(2)}</p>
                  <p style={{ fontSize: '12px', color: '#6b7280', margin: 0 }}>/ 3.5g</p>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '48px 16px' }}>
      <div style={{ 
        overflow: 'hidden', 
        marginBottom: '32px', 
        border: '1px solid #e5e7eb', 
        borderRadius: '8px' 
      }}>
        <div style={{ position: 'relative', height: '192px', width: '100%' }}>
          <img 
            src={dispensary.image || "/placeholder.svg"} 
            alt={dispensary.name} 
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'cover' 
            }} 
          />
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(to top, rgba(0,0,0,0.6), transparent)'
          }} />
          <div style={{ position: 'absolute', bottom: 0, left: 0, padding: '24px' }}>
            <h1 style={{ fontSize: '36px', fontWeight: 'bold', color: 'white', margin: 0 }}>{dispensary.name}</h1>
            <span style={{
              marginTop: '8px',
              display: 'inline-block',
              padding: '4px 8px',
              borderRadius: '4px',
              fontSize: '14px',
              backgroundColor: dispensary.location === "MA" ? '#2563eb' : '#6b7280',
              color: 'white'
            }}>
              {dispensary.location}
            </span>
          </div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '32px' }}>
        <div>
          <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
            <div style={{ padding: '16px', borderBottom: '1px solid #e5e7eb' }}>
              <h3 style={{ fontWeight: '600', margin: 0 }}>Details</h3>
            </div>
            <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '14px' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <span style={{ color: '#6b7280' }}>📍</span>
                <span>
                  {dispensary.city}, {dispensary.location}
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <span style={{ color: '#6b7280' }}>🕐</span>
                <span>Open 9:00 AM - 9:00 PM</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <span style={{ color: '#6b7280' }}>⭐</span>
                <span>
                  {dispensary.rating} stars ({dispensary.reviewCount} reviews)
                </span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div style={{ width: '100%' }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              backgroundColor: '#f3f4f6',
              borderRadius: '8px',
              padding: '4px'
            }}>
              <button style={{
                padding: '8px 12px',
                fontSize: '14px',
                fontWeight: '500',
                borderRadius: '6px',
                backgroundColor: 'white',
                boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                border: 'none',
                cursor: 'pointer'
              }}>
                Flower
              </button>
              <button style={{
                padding: '8px 12px',
                fontSize: '14px',
                fontWeight: '500',
                borderRadius: '6px',
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer'
              }}>
                Edibles
              </button>
              <button style={{
                padding: '8px 12px',
                fontSize: '14px',
                fontWeight: '500',
                borderRadius: '6px',
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer'
              }}>
                Vapes
              </button>
            </div>
            <div style={{ marginTop: '16px', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
              <div style={{ padding: '8px' }}>{renderMenu(dispensary.menu.flower)}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
